import { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import ModalBase from '../../ModalBase/ModalBase';

function ReCaptchaModal({ isOpen, closeModal }) {
  const refRecaptcha = useRef(null);

  const onChange = (reCaptchaToken) => {
    if (reCaptchaToken) {
      closeModal();
    }
  };

  const onExpired = () => {
    if (refRecaptcha?.current) {
      refRecaptcha.current.reset();
    }
  };

  return (
    <ModalBase
      isOpen={isOpen}
      header="Slow down!"
      body={
        <>
          <p>
            You're answering questions too fast. Please complete the
            verification below to continue.
          </p>
          <ReCAPTCHA
            data-test="recaptcha"
            ref={refRecaptcha}
            size="normal"
            sitekey="6LclsYocAAAAAI3fpu2IXgTfYRU1lbAAnyiloaAi"
            onChange={onChange}
            onExpired={onExpired}
            onErrored={onExpired}
          />
        </>
      }
    />
  );
}

export default ReCaptchaModal;
